/* istanbul ignore file */
import createCache from '@emotion/cache';

const isBrowser = typeof document !== 'undefined';

type OptionalHTMLElement = HTMLElement | undefined;

export default function createEmotionCache() {
  let insertionPoint: OptionalHTMLElement;

  if (isBrowser) {
    const emotionInsertionPoint = document.querySelector(
      'meta[name="emotion-insertion-point"]'
    );
    insertionPoint = (emotionInsertionPoint ??
      undefined) as OptionalHTMLElement;
  }

  return createCache({
    key: 'mui-style',
    insertionPoint
  });
}
